import React from "react";

const QRCode = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
              d="M25.111 26.889V25.11h-5.333v-5.333h5.333v3.555h3.556v3.556h-1.778v3.555h-3.556V34h-3.555v-5.333h3.555v-1.778h1.778ZM34 34h-7.111v-3.556h3.555V26.89H34V34ZM2 2h14.222v14.222H2V2Zm17.778 0H34v14.222H19.778V2ZM2 19.778h14.222V34H2V19.778Zm26.667 0H34v3.555h-5.333v-3.555ZM7.333 7.333v3.556h3.556V7.333H7.333Zm0 17.778v3.556h3.556V25.11H7.333ZM25.111 7.333v3.556h3.556V7.333H25.11Z"
              fill={fill}
        />
    </svg>
);

export default QRCode;